import { useEffect } from 'react';

export default function useOutsideClickDetector(ref, handler) {
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      handler(event);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
    // eslint-disable-next-line
    }, []);
}
